export var LOG = 'gandi-application-logger/LOG';